import Reveal from '@/components/base/Reveal';
import { metricStrip } from '@/mocks/home';

export default function MetricStrip() {
  return (
    <section className="w-full bg-foreground-950 border-y border-foreground-800">
      <div className="w-full px-4 md:px-8 py-6 md:py-7">
        <Reveal className="grid grid-cols-2 lg:grid-cols-4 gap-5 md:gap-8">
          {metricStrip.map((item, index) => (
            <div
              key={item.label}
              className={`flex flex-col ${index !== 0 ? 'lg:border-l lg:border-foreground-800 lg:pl-8' : ''}`}
            >
              <span className="font-heading text-xl md:text-2xl font-bold text-background-50">{item.value}</span>
              <span className="mt-1.5 text-xs md:text-sm text-foreground-400 leading-5">{item.label}</span>
            </div>
          ))}
        </Reveal>
      </div>
    </section>
  );
}